// Constants
import UserSuggestionsConstants from 'Shared/constants/UserSuggestions.constants';

// Schemas
import UserSuggestionsSchema from 'Shared/utils/normalizeJSON/schemas/UserSuggestion.schema';

// Utils
import normalizer from 'Shared/utils/normalizeJSON/normalizer';

// Api
import * as UserSuggestionsAPI from '../api/UserSuggestions.api';

export const fetchUserSuggestionsSuccess = payload => ({
  type: UserSuggestionsConstants.Actions.FETCH_USER_SUGGESTIONS_SUCCESS,
  payload,
});

export const updateUserSuggestionsSuccess = payload => ({
  type: UserSuggestionsConstants.Actions.UPDATE_USER_SUGGESTION_SUCCESS,
  payload,
});

export const fetchUserSuggestions = () => dispatch => {
  return UserSuggestionsAPI.fetchUserSuggestions().then(response => {
    const normalized = normalizer(UserSuggestionsSchema, response.data);
    dispatch(fetchUserSuggestionsSuccess(normalized));
    return response;
  });
};

export const updateUserSuggestion = ({ slug, data }) => dispatch => {
  return UserSuggestionsAPI.updateUserSuggestion({ slug, data }).then(response => {
    const normalized = normalizer(UserSuggestionsSchema, response.data);
    dispatch(updateUserSuggestionsSuccess(normalized));
  });
};
